import React from "react";
import User_Management_Routes from "./user_management_routes/User_Management_Routes";
import User_Management_Sidebar from "./user_management_sidebar/User_Management_Sidebar";
import './User_Management_Page.css'

const User_Management_Page = () => {
  return (
    <section className="User_Management_Page">
      <div className="row me-0 ms-0 p-0">
        <div className="col-xxl-2 col-xl-3">
            <User_Management_Sidebar/>
        </div>
        <div className="col-xxl-10 col-xl-9 p-0">
          <User_Management_Routes />
        </div>
      </div>
    </section>
  );
};

export default User_Management_Page;
